import {Component, Input} from "@angular/core";

@Component({
  template: ''
})
export class BaseDeterminantBuilder {
  @Input() public determinantMapById: { [key: string]: string } = {};

  protected appendDeterminant(det, data) {
    if (!Array.isArray(data)) {
      data = [];
    }
    if (data.length === 0) {
      data.push({
        type: 'OR',
        items: []
      });
    }
    let lastItem = data[data.length - 1];
    if (lastItem.items == null) {
      lastItem = {
        type: 'OR',
        items: []
      };
      data.push(lastItem);
    }
    lastItem.items.push({
      type: det.type || 'OR',
      determinantId: det.determinantId,
    });
    return data;
  }
}
